import { render, staticRenderFns } from "./PendingPayments.vue?vue&type=template&id=a6f96af2"
import script from "./PendingPayments.vue?vue&type=script&lang=js"
export * from "./PendingPayments.vue?vue&type=script&lang=js"
import style0 from "./PendingPayments.vue?vue&type=style&index=0&id=a6f96af2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports